import { getUserAgent } from './get-user-agent';
/**
 * 是否是安卓设备
 * @param ua 浏览器的userAgent
 * @example
 * ```
 *    if (isAndroid()) {
 *      console.log('is android')
 *    }
 * ```
 */
export function isAndroid(ua) {
    if (ua === void 0) { ua = ''; }
    var userAgent = getUserAgent(ua);
    return /android|adr/i.test(userAgent);
}
